import { gql } from '@apollo/client';

export default gql`
  mutation addInfant($bookingReference: String!, $passengerId: String!, $firstName: String!, $lastName: String!) {
    addInfant(bookingReference: $bookingReference, passengerId: $passengerId, firstName: $firstName, lastName: $lastName) {
      reference
    }
  }
`;
